<template>
  <el-container class="f-h">
    <el-header class="toolbar" style="height: 2.5rem">
      <el-row type="flex" justify="space-between">
        <div class="sub-title">
          国医大师预约登记
        </div>
        <div>
          <el-input v-model="condition.keyword" placeholder="证件号码/患者姓名" size="small" v-on:keyup.enter.native="queryEntities(1)" class="condition-wide" clearable>
            <el-button type="info" :loading="searchLoading" slot="append" icon="el-icon-search" @click="queryEntities(1)">查询</el-button>
          </el-input>
        </div>
      </el-row>
    </el-header>
    <el-main style="padding: 0px">
      <el-table v-loading="searchLoading" @filter-change="filterChanged" height="100%" :data="entities.items" @sort-change="handleSortChange" class="main-table">
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button :disabled="scope.row.state !== '审核通过'" type="primary" icon="el-icon-edit" title="编辑" plain circle size="mini" @click="edit(scope.row)"></el-button>
            <el-button :disabled="scope.row.state !== '已收费'" type="success" icon="el-icon-check" title="审核通过" plain circle size="mini" @click="audit(scope.row, true)"></el-button>
            <el-button :disabled="scope.row.state !== '已收费'" type="danger" icon="el-icon-refresh-left" title="审核驳回" plain circle size="mini" @click="audit(scope.row, false)"></el-button>
          </template>
        </el-table-column>
        <el-table-column sortable="custom" label="病情图片" prop="patientName" width="100" align="center">
          <template slot-scope="{row}">
            <el-image v-if="row.imgList" style="width: 80px; height: 80px" :src="row.imgList[0]" :preview-src-list="row.imgList">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column sortable="custom" label="预约状态" prop="state" min-width="90" :filters="dictEnum.NationalPhysiciansOrderState" :filter-multiple="false" column-key="state">
          <template slot-scope="{row}">
            <el-tag v-if="row.state == '已收费'" size="small" effect="plain">{{ row.state }}</el-tag>
            <el-tag v-else-if="row.state == '审核通过'" type="success" size="small" effect="plain">{{ row.state }}</el-tag>
            <el-tag v-else-if="row.state == '审核驳回'" type="danger" size="small" effect="plain">{{ row.state }}</el-tag>
            <el-tag v-else type="info" size="small" effect="plain">{{ row.state }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column sortable="custom" label="患者" prop="name" min-width="80" />
        <el-table-column sortable="custom" label="医生" prop="staffName" min-width="80" />
        <!-- <el-table-column sortable="custom" label="预约流水号" prop="appointmentNo" min-width="100" align="center"></el-table-column> -->
        <el-table-column sortable="custom" label="预约渠道" prop="appointmentChannelCode" min-width="100">
          <template slot-scope="{row}">
            {{ row.appointmentChannelCode | dictText('AppointmentChannel') }}
          </template>
        </el-table-column>
        <el-table-column sortable="custom" label="互联网医院流水号" prop="swIHNo" min-width="130" align="center"></el-table-column>
        <el-table-column sortable="custom" label="就诊号" prop="opNo" min-width="100" align="center" />
        <el-table-column sortable="custom" label="期望就诊日期" prop="expectTakingDate" min-width="100" align="center" />
        <el-table-column sortable="custom" label="实际就诊日期" prop="takingDate" min-width="100" align="center" />
        <el-table-column sortable="custom" label="午别" prop="periodType" min-width="80" align="center" />
        <el-table-column sortable="custom" label="时段" prop="periodStart" min-width="100" align="center">
          <template slot-scope="{row}">
            <span v-if="row.periodStart">{{row.periodStart+'~'+row.periodEnd}}</span>
          </template>
        </el-table-column>
        <el-table-column sortable="custom" label="预约时间" prop="date" min-width="100" align="center" show-overflow-tooltip />
        <el-table-column label="病情描述" prop="illnessDescription" min-width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="既往病史" prop="medicalHistory" min-width="100" show-overflow-tooltip></el-table-column>
      </el-table>
    </el-main>
    <pagination :entities="entities" @queryEntities="queryEntities" :condition="condition" />

    <editor @saved="queryEntities" v-model="entity" :visible.sync="meta.showEditor" :state="meta.auditState" />
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";
import api from "./api";
export default {
  components: {
    editor: () => import("./editor"),
    pagination: () => import("@/components/_com/pagination")
  },
  computed: {
    ...mapGetters(["dict", "Enum", "dictEnum"]),
  },
  data () {
    return {
      searchLoading: false,
      meta: {
        showEditor: false,
        showAudit: false,
        auditState: null
      },
      entity: {},
      condition: {
        sort: "id",
        asc: false,
        pageIndexOnView: 1,
        pageSize: 10
      },
      entities: {
        items: []
      }
    };
  },
  created () {
    this.queryEntities();
  },
  mounted () { },
  methods: {
    handleSortChange ({ prop, order }) {
      this.condition.asc = order === "ascending";
      this.condition.sort = prop;
      this.queryEntities();
    },
    filterChanged (options) {
      Object.assign(this.condition, options);
      this.queryEntities();
    },
    edit (val) {
      this.$set(this, "entity", this.$utils.clone(val));
      this.meta.showEditor = true;
      this.meta.auditState = null
    },
    audit (val, state) {
      this.$set(this, "entity", this.$utils.clone(val));
      this.meta.showEditor = true;
      this.meta.auditState = state ? '审核通过' : '审核驳回'
    },
    queryEntities () {
      this.searchLoading = true;
      api.queryNpOrder(this.condition).then(res => {
        this.entities = res;
        this.entities.items.map(item => {
          if (item.medicalImg) {
            item.imgList = eval(item.medicalImg)
          }
        })
        console.log(this.entities);
      }).catch(err => {
        this.$message.error(err.message || err);
      }).finally(() => {
        this.searchLoading = false;
      });
    },
  }
};
</script>

<style scoped>
.condition-wide {
  width: 15rem;
  margin-left: 0.5rem;
  color: #a5a1a1;
}
</style>
